import React from 'react';
import './SupportDetailsSkeleton.css';

const SupportDetailsSkeleton = () => {
  return (
    <div className="support-details-skeleton-container">
      <div className="support-details-skeleton-breadcrumb" />

      <div className="support-details-skeleton-header">
        <div className="support-details-skeleton-title" />
        <div className="support-details-skeleton-badge" />
      </div>

      <div className="support-details-skeleton-date" />

      <div className="support-details-skeleton-section">
        <div className="support-details-skeleton-section-title" />
        <div className="support-details-skeleton-grid">
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value-badge" />
          </div>
        </div>
        <div className="support-details-skeleton-description">
          <div className="support-details-skeleton-label" />
          <div className="support-details-skeleton-description-box" />
        </div>
      </div>

      <div className="support-details-skeleton-section">
        <div className="support-details-skeleton-section-title" />
        <div className="support-details-skeleton-grid">
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value-badge" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
          <div className="support-details-skeleton-field">
            <div className="support-details-skeleton-label" />
            <div className="support-details-skeleton-value" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportDetailsSkeleton;
